export default "__VITE_ASSET__CNUXdVk8__"